import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPrevious = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 50,
	height: 51,
	viewBox: "0 0 50 51",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M31.4921 7.66666L35.0001 11.1667L19.9711 26.1417L35.0001 41.1657L31.4921 44.6667L16.4651 29.6937C14.5151 27.7547 14.5111 24.5927 16.4561 22.6457L31.4921 7.66666Z",
		fill: "#002938"
	})
});
const ForwardRef = forwardRef(SvgPrevious);
export default ForwardRef;
